// extracted by mini-css-extract-plugin
export var bodySections = "_e0-8";
export var gray = "_e0-7";
export var green = "_e0-4";
export var iconContainer = "_e0-9";
export var iconWidgetContainer = "_e0-1";
export var phoneIcon = "_e0-2";
export var red = "_e0-5";
export var statusDot = "_e0-3";
export var widgetContainer = "_e0-0";
export var yellow = "_e0-6";